module.exports = __webpack_public_path__ + "static/media/cover-turchia.441551b6.png";